import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import shortid from 'shortid';

import { display } from '../../../../../commonStyles.js';
import styles from './styles.js';

import Translatable from '../../../../../components/Translatable';
import MobileCheckButton from './MobileCheckButton';

import { createFiltersQueryStringFromObject } from '../../../../../methods';

import {
    fetchActions,
    filterActions
} from '../../../../../pages/Search/actions';

const mapStateToProps = state => ({
    apiUrl: state.config.apiUrl,
    searchParams: state.searchParams,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => ({
    applyFilterGroupCollectionById: (filterGroupCollection, filterGroupCollectionId) =>
        dispatch(filterActions.applyFilterGroupCollectionById(filterGroupCollection, filterGroupCollectionId)),
    fetchSearchResults: (apiUrl, userLang, location, tag, params, trackingCookieId) =>
        dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, params, trackingCookieId, true))
});

class MobileFilterBar extends Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        applyFilterGroupCollectionById: PropTypes.func.isRequired,
        fetchSearchResults: PropTypes.func.isRequired,
        filterGroupCollections: PropTypes.array.isRequired,
        getActiveFilters: PropTypes.number.isRequired,
        searchParams: PropTypes.object.isRequired,
        toggleFullScreenPanel: PropTypes.func.isRequired,
        trackingCookieId: PropTypes.number,
        userLang: PropTypes.string.isRequired
    }

    applyFilterGroup = (filterGroupCollection, filterGroupCollectionId) => {
        const {
            apiUrl,
            applyFilterGroupCollectionById,
            fetchSearchResults,
            searchParams,
            trackingCookieId,
            userLang
        } = this.props;
        applyFilterGroupCollectionById(filterGroupCollection, filterGroupCollectionId);
        const location = decodeURIComponent(window.location.pathname.split('/')[4]);
        const tag = {
            quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
        };
        const paramsQs = createFiltersQueryStringFromObject(searchParams, filterGroupCollection);
        fetchSearchResults(apiUrl, userLang, location, tag, paramsQs, trackingCookieId);
    }

    handleFilterChange = event => {
        const { applyFilterGroup } = this;
        const { filterGroupCollections } = this.props;
        const filterId = event.target.dataset.filterId;
        const filterGroupId = event.target.dataset.filterGroupId;
        const filterGroupCollectionId = event.target.dataset.filterGroupCollectionId;
        let value;
        if (event.target.dataset.value === 'true') {
            value = false;
        } else {
            value = true;
        }
        const filterGroupCollection = filterGroupCollections.find(fGroupCollection =>
            Number(fGroupCollection.id) === Number(filterGroupCollectionId)
        );
        const filterGroup = filterGroupCollection.filterGroups.find(fGroup =>
            Number(fGroup.id) === Number(filterGroupId)
        );
        const filter = filterGroup.filters.find(f =>
            Number(f.id) === Number(filterId)
        );
        const updatedFilter = {
            ...filter,
            data: {
                ...filter.data,
                value
            }
        };
        const updatedFilters = filterGroup.filters.map(f => {
            if (Number(f.id) !== Number(filterId)) {
                return f;
            }
            return {
                ...f,
                ...updatedFilter
            };
        });
        const updatedFilterGroups = filterGroupCollection.filterGroups.map(fGroup => {
            if (Number(fGroup.id) !== Number(filterGroupId)) {
                return fGroup;
            }
            return {
                ...fGroup,
                filters: updatedFilters
            };
        });
        const updatedFilterGroupCollection = {
            ...filterGroupCollection,
            filterGroups: updatedFilterGroups
        };
        applyFilterGroup(updatedFilterGroupCollection, filterGroupCollectionId);
    }

    renderMobileCheckButton = (filter, filterGroup, filterGroupCollection) => {
        const { handleFilterChange } = this;
        return (
            <MobileCheckButton
                key={shortid.generate()}
                filter={filter}
                filterGroup={filterGroup}
                filterGroupCollection={filterGroupCollection}
                handleFilterChange={handleFilterChange}
            />
        );
    }

    render() {
        // const { renderMobileCheckButton } = this;
        const {
            // filterGroupCollections,
            getActiveFilters,
            toggleFullScreenPanel
        } = this.props;
        // const filterGroupCollection = filterGroupCollections.find(fGroupCollection =>
        //     Number(fGroupCollection.id) === 2
        // );
        return (
            <div>
                <div className={css(styles.filterRow)}>
                    <div className={css(styles.buttonScrollCover)} />
                    <button
                        className={css(styles.button, styles.moreFiltersButton)}
                        onClick={toggleFullScreenPanel}
                    >
                        <span>
                            <span className={css(styles.filterText)}>
                                <Translatable
                                    content={{
                                        transKey: 'search.filters'
                                    }}
                                />
                            </span>
                            {
                                Number(getActiveFilters) > 0 ?
                                    <span className={css(styles.wrapper)}>
                                        <div
                                            className={css(display.inlineBlock)}
                                            style={{ marginLeft: '6px' }}
                                        >
                                            <div
                                                className={css(styles.badgeContainer)}
                                                aria-label={`${getActiveFilters} filters applied`}
                                            >
                                                {getActiveFilters}
                                            </div>
                                        </div>
                                    </span> :
                                    <svg
                                        viewBox="0 0 12 12"
                                        role="presentation"
                                        aria-hidden="true"
                                        focusable="false"
                                        style={{
                                            fill: 'currentcolor',
                                            height: '10px',
                                            width: '10px'
                                        }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M2.5.25a.75.75 0 0 0-.75.75v.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0V5.622a2.25 2.25 0 0 0 0-4.244V1A.75.75 0 0 0 2.5.25zm0 4a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm3.5-4a.75.75 0 0 0-.75.75v5.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0v-.378a2.25 2.25 0 0 0 0-4.244V1A.75.75 0 0 0 6 .25zm0 9a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm4.25-7.872V1a.75.75 0 0 0-1.5 0v.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0V5.622a2.25 2.25 0 0 0 0-4.244zM9.5 4.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
                                        />
                                    </svg>
                            }
                        </span>
                    </button>
                    <span className={css(styles.scrollRegion)}>
                        <span className={css(styles.button, styles.fakeFiltersButton)}>
                            <span>
                                <span className={css(styles.textSpan)}>
                                    <Translatable
                                        content={{
                                            transKey: 'search.filters'
                                        }}
                                    />
                                </span>
                                {
                                    Number(getActiveFilters) > 0 ?
                                        <span className={css(styles.wrapper)}>
                                            <div
                                                className={css(display.inlineBlock)}
                                                style={{ marginLeft: '6px' }}
                                            >
                                                <div
                                                    className={css(styles.badgeContainer)}
                                                    aria-label={`${getActiveFilters} filters applied`}
                                                >
                                                    {getActiveFilters}
                                                </div>
                                            </div>
                                        </span> :
                                        <svg
                                            viewBox="0 0 12 12"
                                            role="presentation"
                                            aria-hidden="true"
                                            focusable="false"
                                            style={{
                                                fill: 'currentcolor',
                                                height: '10px',
                                                width: '10px'
                                            }}
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M2.5.25a.75.75 0 0 0-.75.75v.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0V5.622a2.25 2.25 0 0 0 0-4.244V1A.75.75 0 0 0 2.5.25zm0 4a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm3.5-4a.75.75 0 0 0-.75.75v5.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0v-.378a2.25 2.25 0 0 0 0-4.244V1A.75.75 0 0 0 6 .25zm0 9a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm4.25-7.872V1a.75.75 0 0 0-1.5 0v.378a2.25 2.25 0 0 0 0 4.244V11a.75.75 0 0 0 1.5 0V5.622a2.25 2.25 0 0 0 0-4.244zM9.5 4.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
                                            />
                                        </svg>
                                }
                            </span>
                        </span>
                    </span>
                </div>
                <div className={css(styles.spacing)} />
            </div>
        );
    }
}

//<span>
//    {
//        filterGroupCollection.filterGroups.map(filterGroup =>
//            filterGroup.filters.map(filter => renderMobileCheckButton(filter, filterGroup, filterGroupCollection))
//        )
//    }
//</span>

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilterBar);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/MobileFilterBar/MobileFilterBar.jsx